import Button from '~/components/Button';
import { useProjectContext } from '~/hooks';
import StorageForm from './StorageForm';
import WorksheetForm from '../../../../worksheets/common/components/WorksheetForm';
import { ProjectStorage } from '~/types/project';
import '../collapsibleCard.scss';

export default function Storage() {
  const { project, updateProjectValue } = useProjectContext();
  const storageList = project?.storage ?? [];

  const addRow = () => {
    updateProjectValue('', {
      storage: [...storageList, { order: storageList.length }],
      hasStorage: true,
    }, { patch: true });
  };

  const removeRow = (storage: ProjectStorage) => {
    const newStorage = storageList
      .filter((row) => row.order !== storage.order)
      .map((row, index) => ({ ...row, order: index }));

    updateProjectValue('', {
      storage: newStorage,
      hasStorage: Boolean(newStorage.length),
    }, { patch: true });
  };

  if (!storageList.length) {
    return (
      <div className="collapsible-card-empty">
        <p>No storage systems configured yet</p>
        <Button variant="link" onClick={addRow}>
          + Add storage
        </Button>
      </div>
    );
  }

  return (
    <WorksheetForm>
      {storageList.map((storage) => (
        <StorageForm key={storage.id} storage={storage} removeRow={removeRow} />
      ))}
      <div className="collapsible-card-list-actions">
        <Button variant="link" onClick={addRow}>
          + Add another storage system
        </Button>
      </div>
    </WorksheetForm>
  );
}
